import styled from "styled-components";

import { colors } from "@/styles/Variants";

const color = colors.bild;

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const Checkbox = styled.span<{ checked: boolean }>`
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 2px solid ${color.vader300};
  border-radius: 4px;
  transition: all 200ms;
  margin-right: 9px;

  &:after {
    content: "";
    position: absolute;
    display: ${({ checked }) => (checked ? "block" : "none")};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%) rotate(45deg);
    width: 6px;
    height: 10px;
    border: solid ${color.chewie500};
    border-width: 0 2px 2px 0;
    border-bottom-right-radius: 1px;
  }
`;

export const LabelText = styled.span`
  max-width: calc(100% - 33px);
  word-wrap: break-word;
  align-self: center;
  line-height: 1.3;
  color: ${color.vader500};
`;
